import r, { useState as d } from "react";
function E(t) {
  const [, e] = t;
  return typeof e == "string" && e.length > 0;
}
function g([t, e]) {
  return Array.isArray(e) ? [t, e.join(",")] : [t, e];
}
function h(t) {
  return Object.entries(t).map(g).filter(E).map(([e, n]) => `${e}=${encodeURIComponent(n)}`).join("&");
}
function y(t) {
  const [e, n] = t.split("@");
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: `
          a>span.roe::after {
            content: "@";
          }
        `
    }
  }), e, /* @__PURE__ */ r.createElement("span", {
    className: "roe"
  }), n);
}
function T({
  bcc: t = [],
  body: e = "",
  cc: n = [],
  children: a,
  email: o,
  subject: m = "",
  ...u
}) {
  const [s, l] = d(!1), c = new URL(`mailto:${o}`);
  c.search = h({ bcc: t, body: e, cc: n, subject: m });
  function i() {
    l(!0);
  }
  const f = a || o, p = a || y(o);
  return /* @__PURE__ */ r.createElement("a", {
    href: s ? c.href : "#",
    onFocus: i,
    onMouseOver: i,
    ...u
  }, s ? f : p);
}
export {
  T as Email
};
